import { connectSubjects } from "@nimble/datamodel/enums/connectSubjects";

export function formatSubjectLabel(subjectKey: string): string {
  const subject = connectSubjects[subjectKey as keyof typeof connectSubjects];
  return subject?.label || subjectKey;
}

export function formatSubjectLabels(subjects: string[] | undefined): string[] {
  if (!subjects) return [];
  return subjects.map(formatSubjectLabel);
}
